import { FC } from 'react';
import PhoneSvg from '@edikk-edikk/country-layout-black-icon/src/phone.svg';
import { FormattedMessage } from 'react-intl';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailContactGroupCss from '../../assets/contacts/contact-group.module.scss';
import advertDetailContactItemCss from '../../assets/contacts/contact-item.module.scss';
import { ContactsPhoneLink } from '#advertDetail/components';

const ContactsPhone: FC = () => {
  const {
    advert: {
      contactData,
    },
  } = useAdvertDetailContext();

  if (!('phone' in contactData)) {
    return null;
  }

  return (
    <div className={advertDetailContactGroupCss.advertDetailContactGroup}>
      <div className={advertDetailContactGroupCss.advertDetailContactGroup__header}>
        <FormattedMessage defaultMessage="Phone number:" />
      </div>
      <div className={advertDetailContactGroupCss.advertDetailContactGroup__value}>
        <div className={advertDetailContactItemCss.advertDetailContactItem}>
          <SvgIcon Component={PhoneSvg} isWithoutFill width={20} height={20} />
          <ContactsPhoneLink />
        </div>
      </div>
    </div>
  );
};

export { ContactsPhone };
